import styled from 'styled-components';
import ButtonPrimary from './ButtonPrimary';

export default styled(ButtonPrimary)`
  position: fixed;
  bottom: 1rem;
  height: 3rem;
  
  transform: translate3d(0, ${({ isVisible }) => isVisible ? 0 : '4rem'}, 0);
  transition: transform 300ms ease,
              opacity 300ms ease;
  opacity: ${({ isVisible }) => isVisible ? 1 : 0};
`;
